import Form, { IChangeEvent } from "@rjsf/core";
import { RJSFSchema } from "@rjsf/utils";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  FactoryDigitalmallBackofficeV1Retailer,
  RetailerServiceUpdateRetailerApiArg,
  useRetailerServiceUpdateRetailerMutation,
  useLazyRetailerServiceGetRetailerQuery,
} from "../../app/genericApiGenerated";
import buildRetailer from "./buildRetailer";
import UpdateRetailerFormSchema from "./UpdateRetailerFormSchema";
import UpdateRetailerFormUISchema from "./UpdateRetailerFormUISchema";
import { SLDSFormNew } from "../../@core/components/JSONSchemaForm/JSONSchemaForm";

interface UpdateRetailerFormProps {
  postProcessData?: (data: any) => any;
  onFormSubmitted?: (v: FactoryDigitalmallBackofficeV1Retailer) => void;
  onFormChanged?: (
    data: any,
    obj: FactoryDigitalmallBackofficeV1Retailer | undefined
  ) => void;

  selectedRetailer: string;

  isOpen?: boolean;
  notSpaced?: boolean;
}

const UpdateRetailerForm = React.forwardRef<
  Form<any, RJSFSchema, any>,
  UpdateRetailerFormProps
>((props, ref) => {
  const [formData, setFormData] = useState({});
  const [
    retailerServiceUpdateRetailer, // This is the mutation trigger
    { isLoading }, // This is the destructured mutation result
  ] = useRetailerServiceUpdateRetailerMutation();

  const [retailerTrigger, retailerResult] =
    useLazyRetailerServiceGetRetailerQuery({});

  useEffect(() => {
    if (props.isOpen) {
      retailerTrigger(
        {
          retailer: props.selectedRetailer,
        },
        false
      );
    }
  }, [props.isOpen]);

  useEffect(() => {
    if (retailerResult.isSuccess) {
      setFormData(retailerResult.currentData || {});
    }
  }, [retailerResult.isSuccess]);

  const onSubmit = async (
    { formData: data }: IChangeEvent<any, any>,
    event: React.FormEvent<any>
  ) => {
    data =
      props.postProcessData !== undefined ? props.postProcessData(data) : data;
    const retailerUpdateReq: RetailerServiceUpdateRetailerApiArg = {
      retailer: props.selectedRetailer,

      factoryDigitalmallBackofficeV1Retailer: buildRetailer(
        data,
        retailerResult?.currentData
      ),
    };

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const payload = await retailerServiceUpdateRetailer(
        retailerUpdateReq
      ).unwrap();
      props.onFormSubmitted?.(payload);
    } catch (error) {
      // console.error('rejected', error);
    }
    //
  };

  // console.log(getDefaultFormState());
  return (
    <div className="slds-is-relative">
      <section
        className={classNames({ "slds-p-around_large": !props.notSpaced })}
        style={{ minHeight: "5rem" }}
      >
        <SLDSFormNew
          id="update-retailer-form"
          schema={UpdateRetailerFormSchema as RJSFSchema}
          uiSchema={UpdateRetailerFormUISchema}
          onSubmit={onSubmit}
          formData={formData}
          onChange={({ formData: data }) => {
            props.onFormChanged?.(data, retailerResult?.currentData);
            setFormData(data);
          }}
          isLoading={isLoading || retailerResult.isLoading}
          ref={ref}
        />
      </section>
    </div>
  );
});

export default UpdateRetailerForm;
